import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'
import moment from "moment";

const makeOfCarLength = 100
const modelLength = 100
const maxCarNumberLength = 10
const minCarNumberLength = 7
const registrationNumberLength = 150
const VINLength = 17
const conditionLength = 1500
const additionalInfoLength = 300
const NOW_DATE = moment().utc().add(1, 'day').format('YYYY-MM-DD')

const warningCheckingForInvalidCharacters = `Поле ввода содержит некорректные символы`

const carsSchema  =  Joi.object({
  makeOfCar: Joi.object({
      value: Joi.number(),
      label: Joi.string()
        .required()
        .max(makeOfCarLength)
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-()/" ]*$'))
        .error(errorsResolver({
          required: 'Марка авто обязательное поле',
          max: `Поле не должно иметь больше ${makeOfCarLength} символов`,
          pattern: warningCheckingForInvalidCharacters,
        })),
      models: Joi.any(),
    }
  ).invalid(null)
    .required()
    .min(1)
    .error(errorsResolver({
      invalid: `Марка авто обязательное поле`,
      required: `Марка авто обязательное поле`,
      min: `Марка авто обязательное поле`
    })),
  model: Joi.object({
      value: Joi.string(),
      label: Joi.string()
        .max(modelLength)
        .required()
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-()/" ]*$'))
        .error(errorsResolver({
          required: 'Модель авто обязательное поле',
          max: `Поле не должно иметь больше ${modelLength} символов`,
          pattern: warningCheckingForInvalidCharacters,
        })),
    }
  ).invalid(null)
    .required()
    .min(1)
    .error(errorsResolver({
      invalid: `Модель авто обязательное поле`,
      required: `Модель авто обязательное поле`,
      min: `Модель авто обязательное поле`
    })),
  year: Joi.object({
    label: Joi.number()
      .error(errorsResolver({
        number: `Год выпуска обязательное поле`
      })),
    value: Joi.number()
      .error(errorsResolver({
        number: `Год выпуска обязательное поле`
      }))
  })
    .invalid(null)
    .required()
    .error(errorsResolver({
      invalid: `Год выпуска обязательное поле`,
      required: `Год выпуска обязательное поле`
    })),
  carNumber: Joi.string()
    .max(maxCarNumberLength)
    .min(minCarNumberLength)
    .required()
    .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\- ]*$`))
    .error(errorsResolver({
      required: 'Гос. номер обязательное поле',
      max: `Поле не должно иметь больше ${maxCarNumberLength} символов`,
      min: `Поле должно быть не менее ${minCarNumberLength} символов`,
      pattern: warningCheckingForInvalidCharacters,
    })),
  quantity: Joi.number()
    .required()
    .min(1)
    .max(1)
    .error(errorsResolver({
      required: 'Количество обязательное поле',
      numberMin: 'Количество должно быть больше 0',
      max: `Количество должно быть не больше 1`,
      numberUnsafe: 'Некорректное число'
    })),
  estimatedPrice: Joi.number()
    .required()
    .min(0.01)
    .max(999999999999.99)
    .empty('')
    .error(errorsResolver({
      required: 'Оценочная стоимость обязательное поле',
      numberBase: 'Оценочная стоимость должна быть числом',
      numberMin: 'Оценочная стоимость должна быть больше 0',
      numberMax: 'Максимальное число 999999999999.99',
      numberUnsafe: 'Некорректное число'
    })),
  marketPrice: Joi.number()
    .required()
    .min(0.01)
    .max(999999999999.99)
    .empty('')
    .error(errorsResolver({
      required: 'Рыночная стоимость обязатльное поле',
      numberBase: 'Оценочная стоимость должна быть числом',
      numberMin: 'Оценочная стоимость должна быть больше 0',
      numberMax: 'Максимальное число 999999999999.99',
      numberUnsafe: 'Некорректное число'
    })),
  registrationNumber: Joi.string()
    .max(registrationNumberLength)
    .required()
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?"`\\- ]*$'))
    .error(errorsResolver({
      required: 'Номер свид. регистрации обязательное поле',
      max: `Поле не должно иметь больше ${registrationNumberLength} символов`,
      pattern: warningCheckingForInvalidCharacters,
    })),
  registrationDate: Joi.date()
    .iso()
    .less(NOW_DATE)
    .required()
    .error(errorsResolver({
      dateFormat: `Некорректная дата`,
      dateLess: `Дата выдачи должна быть не ранее сегодняшнего дня`,
      required: 'Дата выдачи свид. регистрации обязательное поле',
    })),
  VIN: Joi.string()
    .max(VINLength)
    .min(VINLength)
    .required()
    .pattern(new RegExp(`^[a-zA-Z-0-9]*$`))
    .error(errorsResolver({
      max: `VIN номер должен содержать ${VINLength} символов`,
      min: `VIN номер должен содержать ${VINLength} символов`,
      required: 'VIN номер обязательное поле',
      pattern: warningCheckingForInvalidCharacters,
    })),
  garage: Joi.string()
    .required()
    .error(errorsResolver({
      required: `Выберите хранение или без хранения в ломбарде`,
    })),
  condition: Joi.string()
    .required()
    .trim()
    .max(conditionLength)
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?"`\\-\\r\\n ]*$'))
    .error(errorsResolver({
      required: `Состояние ТС обязательное поле`,
      max: `Длина комментария должна быть меньше или равна ${conditionLength} символам`,
      pattern: warningCheckingForInvalidCharacters,
    })),
  additionalInfo: Joi.string()
    .allow('')
    .max(additionalInfoLength)
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\-,/+!{}#()$%^&*~_№:?"\\\\ \\n]*$'))
    .error(errorsResolver({
      max: `Длина комментария должна быть меньше или равна ${additionalInfoLength} символам`,
      pattern: warningCheckingForInvalidCharacters,
    }))
})

const carsFormSchema = Joi.object({
  cars: carsSchema,
})

export default carsFormSchema
